import * as API from "middleware/api";

export const directDebitList = (valuesForm) => API.executeWithAccessToken("/list.direct.debit", valuesForm);

export const directDebitCreatePre = () => API.executeWithAccessToken("/direct.debit.create.pre");
export const directDebitCreatePreview = (valuesForm) =>
    API.executeWithAccessToken("/direct.debit.create.preview", valuesForm);
export const directDebitSend = (valuesForm) => API.executeWithAccessToken("/direct.debit.create.send", valuesForm);

export const downloadDirectDebitDetailFileMiddleware = (format, idTransaction) =>
    API.executeWithAccessToken("/direct.debit.detail.files.download", {
        format,
        idTransactionLines: idTransaction,
    });
